// /guide/beginner-guide/tipstar/ で使用 => ページは非公開

import { Swiper, Navigation, Pagination } from 'swiper/core';
Swiper.use([Navigation, Pagination]);


export default () => {

  const s = {}
  const init = () => {
    s.slides = document.querySelectorAll('.gu-b-tipstar-slide');
    console.log(s.slides);

    if (!s.slides.length) {
      return
    }

    buildSlides();
    returnActiveStateSwiper();
  }

  const buildSlides = () => {
    s.swipers = [];
    s.slides.forEach((slide, sIdx) => {
      s.swipers[sIdx] = buildslide(slide);
    });
  }
  const buildslide = (swiperRoot) => {
    const container = swiperRoot.querySelector('.gu-b-tipstar-slide__container');
    const fractionTxtEle = swiperRoot.querySelector('.gu-b-tipstar-slide__fraction-txt');
    const swiperOption = {
      pagination: {
        el: fractionTxtEle,
        type: 'fraction',
        modifierClass: 'gu-b-tipstar-slide-',
        currentClass: 'gu-b-tipstar-slide__fraction-current',
        totalClass: 'gu-b-tipstar-slide__fraction-total',
        renderFraction: () => fractionTxtEle.innerHTML,
      },
      navigation: {
        nextEl: swiperRoot.querySelector('.gu-b-tipstar-slide__btn._next'),
        prevEl: swiperRoot.querySelector('.gu-b-tipstar-slide__btn._prev'),
      }
    }
    const swiper = new Swiper(container, swiperOption);

    return swiper;
  }

  const returnActiveStateSwiper = () => {
    const switchingTabs = document.querySelectorAll('.gu-b-tipstar__tab');
    switchingTabs.forEach(tab => {
      tab.addEventListener('click', () => {
        s.swipers.forEach(swip => swip.update())
      })
    })
  }

  init()

}
